import { Component, Input, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import get from 'lodash-es/get';

import { Location } from '@finder/features/calendars/calendars.interface';
import { CalendarsService } from '@finder/features/calendars/services/calendar.service';

@Component({
    selector: 'finder-park-table',
    templateUrl: './park-table.component.html',
    styleUrls: ['./park-table.component.scss']
})
export class ParkTableComponent implements OnInit {

    @Input() location: Location;
    @Input() labels: any;
    @Input() icons: any;

    loading = false;
    icon: string;

    private destroy$ = new Subject<void>();

    constructor(
        private calendarService: CalendarsService,
    ) { }

    ngOnInit() {
        this.icon = get(this.icons, this.location.urlFriendlyId);
        this.calendarService.getLoadingState()
            .pipe(takeUntil(this.destroy$))
            .subscribe(state => this.loading = state);
    }

}
